import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BlobResponse } from '../../Models/OtherClasses';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CustomerInvoiceService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('CustomerInvoice');
	}

	loadAllUnpaid(): Observable<TooBig4Car.Logic.CustomerInvoice[]> {
		return this.myBaseService.loadAll(this.url);
	}
	loadAllForCustomer(id: System.Guid): Observable<TooBig4Car.Logic.CustomerInvoice[]> {
		return this.myBaseService.loadAll(this.url + '/ForCustomer/' + (id || ''));
	}
	save(tempItem: TooBig4Car.Logic.ObjectBase): Observable<TooBig4Car.Logic.CustomerInvoice> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.CustomerInvoice> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid): Observable<TooBig4Car.Logic.CustomerInvoice> {
		return this.myBaseService.get(id, this.url);
	}
	getBreakdownReport(id: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url +'/' + (id ?? '') + '/Report');
	}

	invoicePickupDelivery(id: System.Guid): Observable<TooBig4Car.Logic.CustomerInvoice> {
		return this.myBaseService.post(null, this.url + '/ForPickupDelivery/' + (id || ''), true);
	}
	invoiceCustomer(id: System.Guid): Observable<string> {
		return this.myBaseService.post(null, this.url + '/ForCustomer/' + (id || ''), true);
	}
	search(searchTerm: string): Observable<TooBig4Car.Logic.CustomerInvoice[]> {
		return this.myBaseService.post(searchTerm, this.url + '/Search', false);
	}
}

